import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import type { FieldOption } from '@escuela/ficha-domain'

interface SegmentedProps {
  options: readonly FieldOption[]
  value: string
  onChange: (value: string) => void
  /** Permite deseleccionar tocando la opcion activa. */
  allowClear?: boolean
  ariaLabel?: string
}

/**
 * Single-choice equivalente web del SegmentedControl de la app. Grupo de
 * botones; el activo queda resaltado. Si `allowClear`, re-tocar el activo lo
 * deselecciona (valor '').
 */
export function Segmented({
  options,
  value,
  onChange,
  allowClear = true,
  ariaLabel,
}: SegmentedProps): ReactNode {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className="flex flex-wrap gap-2"
    >
      {options.map((opt) => {
        const active = opt.value === value
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(allowClear && active ? '' : opt.value)}
            className={cn(
              'rounded-md border px-3 py-1.5 text-sm font-medium transition-colors',
              active
                ? 'border-primary bg-primary text-primary-foreground'
                : 'border-input bg-background text-foreground hover:bg-accent hover:text-accent-foreground',
            )}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
